<div class="text-align-center display-flex flex-direction-column">
  <img alt="icon" class="mb-4" height="48" width="48" [src]="'icons/ice-explainer-icon.svg' | assetUrl" />

  <h3 class="t-5@r color-void mb-4">{{ memberService.account.site.name }} Match</h3>

  <div class="t-8@r mb-4">
    This conversation was started with your greeting. Many successful relationships begin this way on
    {{ memberService.account.site.name }}.
  </div>

  <div class="t-6@r color-void mb-6">Reply and see where it leads.</div>

  <button sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-green'" (click)="close()">Got it</button>
</div>
